<article class="container_resolution">
  <section class="resolution-item-section">
    <div class="resolution-detail">
      <span class="large-span bold-span">{{ minuteResolution.userName }}</span>
      <span class="small-span">{{ minuteResolution.comments }}</span>
      <span>{{ minuteResolution.resolutedAt | date : "dd/MM/yyyy " : '-08:00' }}</span>
      <span>{{ minuteResolution.resolutedAt | date:'shortTime':'-08:00' }}</span>
    </div>
    <div>
      <fa-icon size="2x" [class]="iconColor" [icon]="iconResolution"> </fa-icon>
    </div>
  </section>
</article>
